import { useLocalstorageState } from 'rooks';
import { Trophy, UserRound } from 'lucide-react';

import { cn } from '@/utils';

import { Button } from '@/components/ui/button';

const CoachClientTabs = () => {
  const [bookingView, setBookingView] = useLocalstorageState(
    `booking-view`,
    'coach'
  );

  return (
    <div className="flex items-center justify-center space-x-4 mb-4">
      <Button
        variant="outline"
        className={cn(
          'w-1/2 transition-transform duration-300',
          bookingView === 'client' &&
            'border-2 bg-muted text-white transform scale-105 shadow-lg',
          'hover:bg-muted'
        )}
        onClick={() => setBookingView('client')}
      >
        <UserRound className="w-5 h-5 mr-2" />
        As Client
      </Button>
      <Button
        variant="outline"
        className={cn(
          'w-1/2 transition-transform duration-300',
          bookingView === 'coach' &&
            'border-2 bg-muted text-white transform scale-105 shadow-lg',
          'hover:bg-muted'
        )}
        onClick={() => setBookingView('coach')}
      >
        <Trophy className="w-5 h-5 mr-2" />
        As Pro
      </Button>
    </div>
  );
};

export default CoachClientTabs;
